export const extractFirstFrame = async (videoUrl: string): Promise<string> => {
    return new Promise((resolve) => {
        const video = document.createElement("video");
        console.log("videoUrl", videoUrl);
        video.src = videoUrl;
        video.crossOrigin = "anonymous";
        video.muted = true;

        video.addEventListener("loadeddata", () => {
            video.currentTime = 0.1;
        });

        video.addEventListener("seeked", () => {
            const canvas = document.createElement("canvas");
            canvas.width = 320;
            canvas.height = 180;
            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL("image/jpeg", 0.8));
            }
        });

        video.load();
    });
};
